import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import moment from "moment";
import {
  manageDistributionFormNames,
  distributionFormFields,
  MANAGE_DISTRIBUTION_ROUTES,
  repaymentMethods,
  calculateTotalNoOfInstallments,
  getInterestRateForFrequency,
  CalculateAmortizationSchedule,
  getPeriodicPaymentWithNoOfInstallmentsGiven,
  getPeriodicPayment,
  usCurrency,
} from "../../../../utils";
import { Field, Form, Formik, isEmptyArray, useFormikContext } from "formik";
import payrollFrequency from "../../../../mocks/payrollFrequency.json";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInputDollarBox,
  FieldInputMonthBox,
  FieldInputNumber,
  FieldInputPercentage,
  FieldInputYearBox,
  FormControlDecimal,
  SearchableList,
} from "../../../../components";
import FormControlDays from "../../../../components/FormControlDays/FormControlDays";
import FormControlDaysRight from "../../../../components/FormControlDaysRight/FormControlDaysRight";
import { loanRefinance } from "../../../../services";
import { get, isEmpty } from "lodash";
import CompensationTableNoData from "../../../../components/CompensationTable/CompensationTableNoData";
import { calculateAvailableBalanceForLoan } from "../../../Distribution/LoanRequestContainer/LoanRequestContainer";

const LoanRefinanceRequest = ({
  isReFinancing,
  loanData,
  loanSettingInfo,
  setLoanRemaningAmount,
  setPeriodicPaymentVal,
  periodicPaymentVal,
  setFirstDate,
  setNoOfInstallments,
  repaymentSchedule,
  planData,
}) => {
  const { values, setFieldValue, handleChange, errors } = useFormikContext();
  const formName = manageDistributionFormNames.LOAN_REFINANCE_REQUEST;
  const fields = distributionFormFields[formName];

  const maximumLoanRequestAmount = calculateAvailableBalanceForLoan(planData);
  useEffect(() => {
    const newMonths = parseInt(values.tenureMonths);
    const newYears = parseInt(values.tenureYears);

    var requestedAmountFinal = 0;
    var InterestRateFinal = 0;
    var repaymentFrequency = (repaymentFrequency = payrollFrequency.data
      .find((_) => _.value == loanData.repaymentFrequency)
      ?.label.replace("-", ""));

    if (isReFinancing) {
      requestedAmountFinal = values[fields.loanAmount] + loanRemaningAmount;
      InterestRateFinal = values[fields.interestRate];
    } else {
      requestedAmountFinal = loanRemaningAmount;
      InterestRateFinal = loanData.interestRate;
      if (
        values[fields.repaymentMethod] == 1 &&
        ![null, undefined, ""].includes(values[fields.repaymentFrequency])
      ) {
        repaymentFrequency = payrollFrequency.data
          .find((_) => _.value == values[fields.repaymentFrequency])
          ?.label.replace("-", "");
      } else {
        repaymentFrequency = repaymentFrequency = payrollFrequency.data
          .find((_) => _.value == loanData.repaymentFrequency)
          ?.label.replace("-", "");
      }
    }

    const amortizationDataForTenureChange = CalculateAmortizationSchedule({
      frequency: repaymentFrequency,
      loanRequestAmout: requestedAmountFinal,
      interest: InterestRateFinal,
      tenureYears: newYears,
      tenureMonths: newMonths,
      periodicPayment: 0,
      firstRepaymentDate: get(loanData, "firstRepaymentDate", null),
    });
    console.log("kiran use effect", amortizationDataForTenureChange);
    let noOfRemainingInstallments = 0;
    let noOfPassedInstallments = 1;
    amortizationDataForTenureChange.forEach((item) => {
      const date = new Date(item.firstRepaymentDate);
      const currentDate = new Date();
      if (date > currentDate) {
        noOfRemainingInstallments++;
      } else {
        noOfPassedInstallments++;
      }
    });

    // console.log(
    //   "kiran date",
    //   amortizationDataForTenureChange[noOfPassedInstallments].firstRepaymentDate
    // );
    setNoOfInstallments(noOfRemainingInstallments);
    setFirstDate(
      amortizationDataForTenureChange[noOfPassedInstallments]
        ?.firstRepaymentDate
    );
    if (requestedAmountFinal) {
      const newPeriodicPayment = getPeriodicPaymentWithNoOfInstallmentsGiven(
        requestedAmountFinal,
        noOfRemainingInstallments,
        InterestRateFinal,
        repaymentFrequency
      );
      if (isReFinancing) {
        // periodicPaymentVal=newPeriodicPayment;
        setPeriodicPaymentVal(newPeriodicPayment);
      } else {
        setFieldValue(fields.periodicPaymentAmount, newPeriodicPayment);
      }
    }
  }, [
    values[fields.loanAmount],
    values[fields.interestRate],
    // values[fields.tenureYears],
    // values[fields.tenureMonths],
    values[fields.repaymentFrequency],
    values[fields.repaymentMethod],
  ]);

  var frequencyS = payrollFrequency.data
    .find((_) => _.value == loanData.repaymentFrequency)
    ?.label.replace("-", "");

  if (
    values[fields.repaymentMethod] == 1 &&
    ![null, undefined, ""].includes(values[fields.repaymentFrequency])
  ) {
    frequencyS = payrollFrequency.data
      .find((_) => _.value == values[fields.repaymentFrequency])
      ?.label.replace("-", "");
  }
  const amortizationDataNew = CalculateAmortizationSchedule({
    frequency: frequencyS,
    loanRequestAmout: get(loanData, "requestedAmount", null),
    interest: get(loanData, "interestRate", null),

    tenureYears: get(loanSettingInfo, "maximumLengthYears", null),
    tenureMonths: get(loanSettingInfo, "maximumLengthMonths", null),
    periodicPayment: 0,
    firstRepaymentDate: get(loanData, "firstRepaymentDate", null),
  });
  let noOfRemainingInstallments = 0;
  amortizationDataNew.forEach((item) => {
    const date = new Date(item.firstRepaymentDate);
    const currentDate = new Date();
    if (date > currentDate) {
      noOfRemainingInstallments++;
    }
  });

  const loanActivationDate = new Date(loanData.loanActivationDate);
  let array = repaymentSchedule ?? [];

  var loanRemaningAmount = loanData["outstandingBalance"];
  var currentDate = moment(new Date());
  var lastRepaymentEntryDate = new Date();
  var lastRepaymentEntry = !isEmpty(array) ? array[array.length - 1] : null;
  var accuredInterest = 0.0;

  var modifiedLoans =
    !isEmpty(repaymentSchedule) &&
    repaymentSchedule?.[repaymentSchedule.length - 1];

  if (
    lastRepaymentEntry != null &&
    modifiedLoans?.loanSuspension == null &&
    modifiedLoans?.reAmortizationRequestDetails == null
  ) {
    lastRepaymentEntryDate = moment(new Date(lastRepaymentEntry.repaymentDate));
    if (currentDate > lastRepaymentEntryDate) {
      let diffDays = currentDate.diff(lastRepaymentEntryDate, "days");
      accuredInterest =
        diffDays * (loanData.interestRate / 36500) * loanRemaningAmount;
    }
  } else {
    lastRepaymentEntryDate = moment(new Date(loanData.loanActivationDate));

    if (currentDate > lastRepaymentEntryDate) {
      let diffDays = currentDate.diff(lastRepaymentEntryDate, "days");
      accuredInterest =
        diffDays * (loanData.interestRate / 36500) * loanRemaningAmount;
    }
  }

  loanRemaningAmount = loanRemaningAmount + accuredInterest;
  setLoanRemaningAmount(loanRemaningAmount);
  const periodicPaymentMaxValidation = (value) => {
    let error;
    if (value > loanRemaningAmount) {
      error =
        "Periodic payment amount cannot be greater than loan request amount";
      return error;
    }
  };
  const LoanMinimumLength = (loanSettingInfo) => {
    var ans = 0;
    switch (loanSettingInfo.minimumLength) {
      case 1:
        ans = 3;
        break;
      case 2:
        ans = 6;
        break;

      case 3:
        ans = 12;
        break;
    }
    return ans;
  };
  const loanMaximumTenure =
    loanSettingInfo.maximumLengthYears * 12 + loanSettingInfo;
  const applicablePaymentMethod = get(
    loanSettingInfo,
    "applicablePaymentMethods",
    []
  );
  const repaymentMethodsOptions =
    applicablePaymentMethod.length == 2
      ? repaymentMethods
      : repaymentMethods.filter(({ value }) =>
          get(loanSettingInfo, "applicablePaymentMethods", [])?.includes(value)
        );

  const tenureMinimumTenureValidation = (value) => {
    let error;
    if (value * 12 + values[fields.tenureMonths] > loanMaximumTenure) {
      error = "Tenure Great";
      return error;
    }
  };

  const handlePeriodicPaymentChangeFunction = (value) => {
    if (value && loanRemaningAmount) {
      var tenure = getTenure(loanRemaningAmount, parseFloat(value));
      console.log("tenure log", tenure);
      const noOfInstallments = Math.ceil(
        calculateTotalNoOfInstallments(frequencyS, 0, tenure ?? 0)
      );
      setNoOfInstallments(noOfInstallments);
      var loanActivationDate = new Date(loanData.loanActivationDate);
      console.log("loanActivationDate", loanActivationDate);
      const currentDate = new Date();

      // if (currentDate > loanActivationDate) {
      //   const diffTime = Math.abs(currentDate - loanActivationDate);

      //   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      //   tenure = tenure + diffDays;

      //   console.log("Diff days", diffDays);
      // }
      const newMonths = parseInt(values.tenureMonths);
      const newYears = parseInt(values.tenureYears);

      var remainingLoanAmount = loanRemaningAmount;
      var interestRate = loanData.interestRate;
      if (isReFinancing) {
        remainingLoanAmount = values[fields.loanAmount] + loanRemaningAmount;
        interestRate = values[fields.interestRate];
      }

      const amortizationDataForTenureChangee = CalculateAmortizationSchedule({
        frequency: frequencyS,
        loanRequestAmout: remainingLoanAmount,
        interest: interestRate,
        tenureYears: newYears,
        tenureMonths: newMonths,
        periodicPayment: 0,
        firstRepaymentDate: get(loanData, "firstRepaymentDate", null),
      });

      let noOfRemainingInstallments = 0;
      let noOfPassedInstallments = 0;
      amortizationDataForTenureChangee.forEach((item) => {
        const date = new Date(item.firstRepaymentDate);
        const currentDate = new Date();
        if (date > currentDate) {
          noOfRemainingInstallments++;
        } else {
          noOfPassedInstallments++;
        }
      });

      console.log("No of passed installments", noOfPassedInstallments);
      tenure = tenure + noOfPassedInstallments;
      var years = Math.floor(tenure / 12);
      var months = Math.ceil(tenure % 12);
      if (months == 12) {
        years += 1;
        months = 0;
      }

      setFieldValue(fields.tenureYears, years);
      setFieldValue(fields.tenureMonths, months);
    }
  };

  function getTenure(loanAmount, periodicPayment) {
    const effectiveInterest = getInterestRateForFrequency(
      loanData.interestRate,
      frequencyS
    );

    let num =
      periodicPayment / (periodicPayment - effectiveInterest * loanAmount);
    let denom = 1 + effectiveInterest;
    let lognum = Math.log10(num);
    let logdenom = Math.log10(denom);
    return (
      Math.log10(
        periodicPayment / (periodicPayment - effectiveInterest * loanAmount)
      ) / Math.log10(1 + effectiveInterest)
    );
  }

  const handleTenureChange = (isMonth, value) => {
    const newMonths = isMonth ? parseInt(value) : parseInt(values.tenureMonths);
    const newYears = isMonth ? parseInt(values.tenureYears) : parseInt(value);

    var remainingLoanAmount = loanRemaningAmount;
    var interestRate = loanData.interestRate;
    if (isReFinancing) {
      remainingLoanAmount = values[fields.loanAmount] + loanRemaningAmount;
      interestRate = values[fields.interestRate];
    }

    const amortizationDataForTenureChangee = CalculateAmortizationSchedule({
      frequency: frequencyS,
      loanRequestAmout: remainingLoanAmount,
      interest: interestRate,
      tenureYears: newYears,
      tenureMonths: newMonths,
      periodicPayment: 0,
      firstRepaymentDate: get(loanData, "firstRepaymentDate", null),
    });

    let noOfRemainingInstallments = 0;
    amortizationDataForTenureChangee.forEach((item) => {
      const date = new Date(item.firstRepaymentDate);
      const currentDate = new Date();
      if (date > currentDate) {
        noOfRemainingInstallments++;
      }
    });
    setNoOfInstallments(noOfRemainingInstallments);
    if (value && remainingLoanAmount) {
      const newPeriodicPayment = getPeriodicPaymentWithNoOfInstallmentsGiven(
        remainingLoanAmount,
        noOfRemainingInstallments,
        interestRate,
        frequencyS
      );
      console.log("kiran ans", newPeriodicPayment);

      if (isReFinancing) {
        // periodicPaymentVal=newPeriodicPayment;
        setPeriodicPaymentVal(newPeriodicPayment);
      } else {
        setFieldValue(fields.periodicPaymentAmount, newPeriodicPayment);
      }
    }
  };

  return (
    <>
      <div className="loanrefinance">
        {isReFinancing ? (
          <>
            <div className="d-flex flex-row">
              <div style={{ width: "200px" }}>
                <Field
                  size="sm"
                  isRequired
                  name={fields.loanAmount}
                  type="number"
                  label={"Loan Request Amount"}
                  autoComplete="off"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  max={50000.0}
                  min={0}
                  value={values[fields.loanAmount]}
                  preventNegative={true}
                  component={FieldInputDollarBox}
                  validate={(val) =>
                    ![null, undefined, ""].includes(val) &&
                    (val < loanSettingInfo.minimumAmount ||
                      val > maximumLoanRequestAmount)
                      ? `You may request a min. of ${
                          loanSettingInfo.minimumAmount
                        } to a max. of ${maximumLoanRequestAmount.toFixed(2)}`
                      : undefined
                  }
                />
              </div>
              <div className="d-flex flex-column ml-3 mt-1 ">
                <div className="loanrefinancelabel ">
                  Loan total Requested amount
                </div>
                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "0.8rem",
                    marginLeft: "10px",
                  }}
                >
                  {usCurrency(
                    loanRemaningAmount +
                      (values[fields.loanAmount] == ""
                        ? 0
                        : values[fields.loanAmount])
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "-10px",
              }}
            >
              <FontAwesomeIcon
                style={{ color: "#919191" }}
                icon={faInfoCircle}
              />
              <div className="mb-3 ml-2" style={{ fontSize: "0.75rem" }}>
                {" "}
                Min - $ {loanSettingInfo.minimumAmount} Max - ${" "}
                {maximumLoanRequestAmount.toFixed(2)}{" "}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="loanrefinancelabel">Loan Amount</div>

            <div
              className="mb-3"
              style={{ fontWeight: "500", color: "#242426" }}
            >
              $ {loanData.requestedAmount}
            </div>
          </>
        )}
        {isReFinancing ? (
          <>
            <Field
              size="xxs"
              isRequired
              name={fields.interestRate}
              type="number"
              label={"Interest Rate"}
              autoComplete="off"
              onChange={(e) => {
                handleChange(e);
              }}
              max={100.0}
              min={0}
              value={values[fields.interestRate]}
              component={FieldInputPercentage}
              validate={(val) =>
                ![null, undefined, ""].includes(val) &&
                loanSettingInfo.allowParticipantsToChooseInterestRate ===
                  true &&
                (val < loanSettingInfo.interestRateMinimum ||
                  val > loanSettingInfo.interestRateMaximum)
                  ? `Interest Rate should be between Min ${loanSettingInfo.interestRateMinimum}% - Max ${loanSettingInfo.interestRateMaximum}%`
                  : undefined
              }
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "-10px",
              }}
            >
              {loanSettingInfo.allowParticipantsToChooseInterestRate ===
              true ? (
                <>
                  <FontAwesomeIcon
                    style={{ color: "#919191" }}
                    icon={faInfoCircle}
                  />

                  <div className="mb-3 ml-2" style={{ fontSize: "0.75rem" }}>
                    {" "}
                    Min {loanSettingInfo.interestRateMinimum}% - Max
                    {loanSettingInfo.interestRateMaximum}%
                  </div>
                </>
              ) : (
                <div className="mb-3"></div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="loanrefinancelabel">Interest Rate</div>

            <div
              className="mb-3"
              style={{ fontWeight: "500", color: "#242426" }}
            >
              {loanData.interestRate} %
            </div>
          </>
        )}
        <div className="loanrefinancelabel">Tenure Period</div>
        <div className="d-flex">
          <Field
            size="sm"
            isRequired
            name={fields.tenureYears}
            type="number"
            autoComplete="off"
            onChange={(e) => {
              handleTenureChange(false, e.target.value);
              handleChange(e);
            }}
            max={50000.0}
            min={0}
            value={values[fields.tenureYears]}
            component={FieldInputYearBox}
            validate={(val) =>
              ![null, undefined, ""].includes(val) &&
              (val * 12 + values[fields.tenureMonths] >
                loanSettingInfo.maximumLengthYears * 12 +
                  loanSettingInfo.maximumLengthMonths ||
                val * 12 + values[fields.tenureMonths] <
                  LoanMinimumLength(loanSettingInfo))
                ? ` `
                : undefined
            }
          />
          &nbsp;&nbsp;&nbsp;
          <div
            style={{
              marginLeft: "1rem",
            }}
          ></div>
          <Field
            size="sm"
            isRequired
            name={fields.tenureMonths}
            type="number"
            autoComplete="off"
            onChange={(e) => {
              handleTenureChange(true, e.target.value);
              handleChange(e);
            }}
            max={11}
            min={0}
            value={values[fields.tenureMonths]}
            component={FieldInputMonthBox}
            validate={(val) =>
              ![null, undefined, ""].includes(val) &&
              (val + values[fields.tenureYears] * 12 >
                loanSettingInfo.maximumLengthYears * 12 +
                  loanSettingInfo.maximumLengthMonths ||
                val + values[fields.tenureYears] * 12 <
                  LoanMinimumLength(loanSettingInfo))
                ? `Tenure should be between ${LoanMinimumLength(
                    loanSettingInfo
                  )} months and ${loanSettingInfo.maximumLengthYears} years, ${
                    loanSettingInfo.maximumLengthMonths
                  } months`
                : undefined
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "-10px",
          }}
        >
          <FontAwesomeIcon style={{ color: "#919191" }} icon={faInfoCircle} />
          <div className="mb-3 ml-2" style={{ fontSize: "0.75rem" }}>
            {" "}
            Max - {loanSettingInfo.maximumLengthYears} years and{" "}
            {loanSettingInfo.maximumLengthMonths} months from the original loan
            start date
          </div>
        </div>

        {isReFinancing ? (
          <>
            <div className="loanrefinancelabel">Repayment frequency</div>
            <div
              className="mb-3"
              style={{ fontWeight: "500", color: "#242426" }}
            >
              {payrollFrequency.data
                .find(
                  (_) => _.value == get(loanData, "repaymentFrequency", null)
                )
                ?.label.replace("-", "")}
            </div>
          </>
        ) : (
          <>
            <Field
              isRequired
              name={fields.repaymentMethod}
              size="lg"
              label="Repayment Method"
              options={repaymentMethodsOptions}
              selectedValue={values[fields.repaymentMethod]}
              onChange={(value) => {
                setFieldValue(fields.repaymentMethod, value);
              }}
              value={values[fields.repaymentMethod]}
              component={FieldButtonGroup}
            />
            {values[fields.repaymentMethod] == 1 ? (
              <Field
                name={fields.repaymentFrequency}
                label="Repayment frequency"
                placeholder="Select frequency"
                isRequired
                size={"smd"}
                value={values[fields.repaymentFrequency]}
                options={payrollFrequency.data.filter(
                  (_, index) => _.value !== 3
                )}
                popupContent={
                  <SearchableList
                    label="Select a repayment frequency"
                    options={payrollFrequency.data.filter(
                      (_, index) => _.value !== 3
                    )}
                    onSelect={(value) => {
                      setFieldValue(fields.repaymentFrequency, value);
                    }}
                    selectedValue={values[fields.repaymentFrequency]}
                    name={fields.repaymentFrequency}
                    isNotTypeAhead
                    isRadio
                  />
                }
                validate={(val) =>
                  [null, undefined, ""].includes(val) ? `Required` : undefined
                }
                component={FieldDropSide}
              />
            ) : (
              <>
                <div className="loanrefinancelabel">Repayment frequency</div>
                <div
                  className="mb-3"
                  style={{ fontWeight: "500", color: "#242426" }}
                >
                  {/* {values["repaymentFrequency"]} */}
                  {payrollFrequency.data
                    .find(
                      (_) =>
                        _.value == get(loanData, "repaymentFrequency", null)
                    )
                    ?.label.replace("-", "")}
                </div>
              </>
            )}
          </>
        )}
        {/* <FontAwesomeIcon style={{color:"#919191"}} icon={faInfoCircle} /> */}

        <div className="loanrefinancelabel">Periodic Payment</div>
        {isReFinancing ? (
          <>
            <div
              className="mb-3"
              style={{ fontWeight: "500", color: "#242426" }}
            >
              {periodicPaymentVal}
            </div>
          </>
        ) : (
          <>
            <Field
              size="sm"
              isRequired
              name={fields.periodicPaymentAmount}
              type="number"
              //label={"Loan Request Amount"}
              autoComplete="off"
              onChange={(e) => {
                handleChange(e);
                handlePeriodicPaymentChangeFunction(e.target.value);
              }}
              max={50000.0}
              min={0}
              validate={(val) => periodicPaymentMaxValidation(val)}
              value={values[fields.periodicPaymentAmount]}
              component={FieldInputDollarBox}
              // disabled={isEdit && !isSave}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "-10px",
              }}
            >
              <FontAwesomeIcon
                style={{ color: "#919191" }}
                icon={faInfoCircle}
              />

              <div className="mb-3 ml-2" style={{ fontSize: "0.75rem" }}>
                Periodic Payment should be greater than or equal to $
                {getPeriodicPaymentWithNoOfInstallmentsGiven(
                  loanRemaningAmount,
                  noOfRemainingInstallments,
                  loanData.interestRate,
                  frequencyS
                )}
              </div>
            </div>
          </>
        )}
        <div className="loanrefinancelabel">
          {isReFinancing ? <>Refinancing Fees</> : <>Reamortization Fees</>}
        </div>
        <Field
          size="sm"
          isRequired
          name={fields.transactionFees}
          type="number"
          autoComplete="off"
          onChange={handleChange}
          max={50000.0}
          min={0}
          value={values[fields.transactionFees]}
          component={FieldInputDollarBox}
        />
      </div>
    </>
  );
};
export default LoanRefinanceRequest;
